import UserModelBuilder from './builders/UserModelBuilder';
import { IConfigStorage } from './interfaces/IConfigStorage';
import UserModel from './userModel';

/**
 * @class SettingsModel
 * @description Datos básicos necesarios para persistir en el local storage.
 */
export default class SettingsModel {
  private lang!: string;
  private user: UserModel | undefined;
  private idFunctions: (number | string)[];

  /**
   * @param {IConfigStorage} args Datos que se leen o escriben en el local storage
   */
  constructor (args?: IConfigStorage) {
    this.lang = (args != null) ? args.lang : 'EN';
    this.user = args?.user != null ? new UserModelBuilder(args.user as UserModel).get() : undefined;
    this.idFunctions = args?.idFunctions != null ? args?.idFunctions: [-1];
  }

  /**
   * @description Persiste el lenguaje que llega por parametro
   * @param {string} lang
   * @returns {SettingsModel}
   */
  public setLang = (lang: string): SettingsModel => {
    this.lang = lang;
    return this;
  };

  /**
   * @description Retorna el lenguaje persistido
   * @returns {string}
   */
  public getLang = (): string => this.lang?.length > 0 ? this.lang : '';

  /**
   * @description Persiste el usuario que se envio por parametro
   * @param {UserModel} user
   * @returns {SettingsModel}
   */
  public setUser = (user: UserModel): SettingsModel => {
    this.user = user;
    return this;
  };

  /**
   * @description Retorna el usuario seteado si pudo logearse correctamente.
   * @returns {UserModel}
   */
  public getUser = (): UserModel => (this.user !== undefined ) ? this.user : new UserModel();

  /**
   * @description Persiste la funcion que llegan por parametro
   * @param {(number | string)} id
   * @returns {SettingsModel}
   */
  public setIdFunction = (id: number | string): SettingsModel => {
    this.idFunctions.push(id);
    return this;
  }

  /**
   * @description Persiste las funciones que llegan por parametro
   * @param {(number | string)[]} listId
   * @returns {SettingsModel}
   */
  public setIdFunctions = (listId: (number | string)[]): SettingsModel => {
    this.idFunctions.push(...listId);
    return this;
  }

  /**
   * @description Retorna la lista de funciones persistidas.
   * @returns {(number | string)[]}
   */
  public getIdFunctions = (): (number | string)[] => this.idFunctions;

  /**
   * @description Verifica si existe el id de función en la lista de funciones.
   * @param {number | string} paramID
   * @returns {boolean}
   */
  public getExistsIdFunction = (paramID: number | string ): boolean => {
    const dataExists: (number | string)[] = this.idFunctions.filter((value) => value === paramID);
    return dataExists && dataExists.length > 0;
  }

  /**
   * @description Retorna si los datos del usuario son validos o no.
   * @returns {boolean}
   */
  public userIsValid = (): boolean => {
    const usr = new UserModel(this.user);
    return usr.getFullName() !== '';
  }
}
